// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, signInAnonymously } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
};
let database = null;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

let databasePromise = new Promise((resolve, reject) => {
  signInAnonymously(auth)
    .then((userCredential) => {
      const user = userCredential.user;
      if (user && user.uid) {
        database = getDatabase(app);
        resolve(database);
      } else {
        reject(new Error("Failed to initialize database: User UID is missing."));
      }
    })
    .catch((error) => {
      console.error("Error signing in anonymously:", error);
      reject(error);
    });
});

export { databasePromise };